import { cn } from "@/lib/utils";

/** A labelled on/off switch: the whole row is the button. Settings' rows use it. */
export function SwitchRow({
  label,
  hint,
  checked,
  onChange,
}: {
  label: string;
  hint: string;
  checked: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className="flex w-full items-center gap-3 rounded-md px-1 py-1.5 text-left hover:bg-muted/40"
    >
      <span className="min-w-0 flex-1">
        <span className="block text-[13px] font-medium">{label}</span>
        <span className="block text-[12px] text-muted-foreground">{hint}</span>
      </span>
      <span
        className={cn(
          "relative h-5 w-9 shrink-0 rounded-full border transition-colors",
          checked ? "border-primary bg-primary" : "border-border bg-muted",
        )}
      >
        <span
          className={cn(
            "absolute top-0.5 size-3.5 rounded-full shadow-sm transition-[left]",
            checked ? "left-[18px] bg-primary-foreground" : "left-0.5 bg-muted-foreground",
          )}
        />
      </span>
    </button>
  );
}
